export default __webpack_public_path__ + "static/media/admin-user-img.ea285f41.png";